<template>
  <v-dialog
    v-if="authenticated"
    v-model="createDialog"
    content-class="agent_pop_up"
  >
    <KTPortlet :title="title">
      <template v-slot:body>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <b-form-group label="Full Name:" label-for="fullName">
            <b-form-input
              id="fullName"
              v-model="$v.form.name.$model"
              required
              placeholder="Full Name"
              :state="validateState('name')"
              aria-describedby="agentName-error"
            ></b-form-input>
            <b-form-invalid-feedback id="agentName-error">
              Agent Name is required and must not be less than 3 characters.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Email Address:" label-for="userEmail">
            <b-form-input
              id="userEmail"
              v-model="$v.form.email.$model"
              type="email"
              required
              placeholder="Enter email"
              :state="validateState('email')"
              aria-describedby="agentEmail-error"
            ></b-form-input>
            <b-form-invalid-feedback id="agentEmail-error">
              Agent Email is required and must be a valid email address.
            </b-form-invalid-feedback>
          </b-form-group>

          <div class="d-flex " style="justify-content: flex-end;">
            <b-button
              style="margin-right: 5% ; background-color: #F0F1FF; color:#6A63EB;"
              @click="closeModal"
              >Cancel</b-button
            >

            <b-button
              type="submit"
              variant="primary"
              style="background-color: #6B68E8 ; color:white;"
              >Save</b-button
            >
          </div>
        </b-form>
      </template>
    </KTPortlet>
    <LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
  </v-dialog>
</template>

<script>
import KTPortlet from "@/views/partials/content/Portlet";
import AlertModal from "@/components/widgets/AlertModal.vue";
import LoadingModal from "@/components/widgets/LoadingModal.vue";
import { API, graphqlOperation } from "aws-amplify";
import { inviteUser } from "@/graphql/mutations";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  components: {
    KTPortlet,
    AlertModal,
    LoadingModal
  },
  data: () => {
    return {
      form: {
        name: null,
        email: null
      },
      loadingModal: {
        dialog: false,
        text: ""
      },
      alertModal: {
        show: false,
        text: "",
        type: AlertModal.INFORMATION
      },
      show: true
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      name: {
        required,
        minLenght: minLength(3)
      }
    }
  },
  props: {
    createDialog: Boolean
  },
  computed: {
    title() {
      return `Add New User`;
    },
    authenticated() {
      return this.$role.verify([
        this.$role.ADD_USER,
        this.$role.MERCHANT_ADMIN
      ]);
    }
  },
  methods: {
    closeModal() {
      this.$emit("eCloseCreateAddAgentFormModal");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit: async function(e) {
      e.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.alert("This form is not valid", AlertModal.WARNING);
        return;
      }
      const name = this.form.name;
      const email = this.form.email;

      try {
        this.startLoadingDialog(`Adding ${name}`);
        const result = await this.addAgent(name, email);
        if (result) {
          this.stopLoadingDialog(
            `Successfully Added ${name}`,
            AlertModal.SUCCESS
          );
          this.onReset();
        } else {
          this.stopLoadingDialog(`Unable to add ${name}`, AlertModal.ERROR);
        }
      } catch (e) {
        this.$logger.error(e);
        this.stopLoadingDialog(
          `There was an error adding ${name}`,
          AlertModal.ERROR
        );
      }
    },
    onReset: function() {
      this.form.name = null;
      this.form.email = null;
    },
    addAgent: async function(name, email) {
      const input = {
        name,
        email
      };

      try {
        const response = await API.graphql(
          graphqlOperation(inviteUser, {
            input
          })
        );
        return response.data.inviteUser;
      } catch (e) {
        throw e;
      }
    },
    alert(text, type) {
      if (text) this.alertModal.text = text;
      if (type) this.alertModal.type = type;
      if (this.alertModal.text) this.alertModal.show = true;
    },
    resetAlert() {
      this.alertModal.text = "";
      this.alertModal.type = AlertModal.INFORMATION;
    },
    startLoadingDialog(text) {
      this.loadingModal.text = text;
      this.loadingModal.dialog = true;
    },
    stopLoadingDialog(alertText, alertType, callback) {
      this.loadingModal.dialog = false;
      this.loadingModal.text = "";
      this.alert(alertText, alertType, callback);
    }
  }
};
</script>

<style>
.agent_pop_up {
  max-width: 25%;
}
</style>
